<div class="card-base">
    <div class="card-content-reservation-search">
        <div class="chip-container">
            <mat-chip-list>
                <mat-chip color="accent" matTooltip="{{filt.toolTip}}" selected *ngFor="let filt of searchFilters">
                    {{ filt.valueView }}
                    <mat-icon *ngIf="!filt.isRequired" (click)="filt.remove()">cancel</mat-icon>
                </mat-chip>
            </mat-chip-list>
        </div>
        <div class="card-container mat-elevation-z1">
            <div class="clearfix">
                <div class="pull-right div-header-right">
                    <button class="card-inline margin-top-medium" [matMenuTriggerFor]="columnsMenu" type="button" mat-mini-fab matTooltip="Columnas visibles">
                      <mat-icon>view_column</mat-icon>
                  </button>
                    <mat-menu #columnsMenu="matMenu" class="columns-menu">
                        <button mat-menu-item (click)="showAllColumns()">
                          <span>Mostrar todas</span>
                      </button>
                        <mat-divider></mat-divider>
                        <div class="columns-menu-item" *ngFor="let col of availableColumns" (click)="$event.stopPropagation()">
                            <mat-checkbox [checked]="isColumnVisible(col.field)" (click)="$event.stopPropagation()" (change)="setColumnVisibility(col.field, $event.checked)">
                                {{ col.title }}
                            </mat-checkbox>
                        </div>
                    </mat-menu>
                </div>
                <div class="pull-left div-header-left">
                    <app-search-filter-component #searchFilter (startSearch)="onStartSearch()" (endSearch)="onEndSearch($event)" [filter]="filters"></app-search-filter-component>
                    <app-admision-re-appointment-filter #filters></app-admision-re-appointment-filter>
                </div>
            </div>
            <mat-divider></mat-divider>
            <div class="card-content margin-botton-medium">
                <div class="grid-scroll-container">
                    <p-table class="search-table" [value]="dataSource" [tableStyle]="{ width: '100%' }">
                        <ng-template pTemplate="header">
                            <tr class="search-table-header">
                                <th class="resizable-header" *ngFor="let col of orderedColumnsDefinition" [style.width.px]="getColumnWidth(col.field)" (dragover)="onHeaderDragOver($event)" (drop)="onHeaderDrop($event, col.field)">
                                    <div class="header-top-row">
                                        <span class="header-drag-content">
                                          <span class="column-title" (click)="sortByColumn(col.field)">
                                              {{ col.title }}
                                              <mat-icon class="sort-icon">{{ getSortIcon(col.field) }}</mat-icon>
                                          </span>
                                        <mat-icon class="header-drag-handle" draggable="true" (dragstart)="onHeaderDragStart($event, col.field)" (dragend)="onHeaderDragEnd()" (click)="$event.stopPropagation()">drag_indicator</mat-icon>
                                        </span>
                                        <span class="column-resize-handle" (mousedown)="startResize($event, col.field)"></span>
                                    </div>
                                    <input class="column-filter-input" [value]="columnFilters[col.field] || ''" (click)="$event.stopPropagation()" (input)="onColumnFilterInput(col.field, $event.target.value)" placeholder="Filtrar" />
                                </th>
                                <th class="actions-column"></th>
                            </tr>
                        </ng-template>
                        <ng-template pTemplate="body" let-element>
                            <tr class="search-table-cell">
                                <td *ngFor="let col of orderedColumnsDefinition" [style.width.px]="getColumnWidth(col.field)">
                                    {{ element[col.field] }}
                                </td>
                                <td class="actions-column" (click)="$event.stopPropagation()">
                                    <button mat-icon-button [matMenuTriggerFor]="rowMenu">
                                      <mat-icon>more_vert</mat-icon>
                                  </button>
                                    <mat-menu #rowMenu="matMenu">
                                        <button *ngIf="!loadingAction" mat-menu-item (click)="openPatientViewDialog(element)"><mat-icon>perm_identity</mat-icon><span>Ver paciente</span></button>
                                        <button *ngIf="!loadingAction" mat-menu-item (click)="openOtherMedicalAppointmentDialogDialog(element)"><mat-icon>list</mat-icon><span>Ver otros turnos</span></button>
                                        <button *ngIf="!loadingAction" mat-menu-item (click)="goReminder(element)"><mat-icon>notification_important</mat-icon><span>Ir a recordatorio</span></button>
                                        <button *ngIf="!loadingAction" mat-menu-item (click)="openMedicalAppointmentObservationDialog(element)"><mat-icon>search</mat-icon><span>Ver observaciones</span></button>
                                        <button *ngIf="!loadingAction" mat-menu-item (click)="assignMedicalAppointment(element)"><mat-icon>redo</mat-icon><span>Nuevo turno</span></button>
                                        <button *ngIf="!loadingAction" mat-menu-item (click)="goMedicalOrderScann(element)"><mat-icon>scanner</mat-icon><span>Ver escaneos</span></button>
                                    </mat-menu>
                                </td>
                            </tr>
                        </ng-template>
                    </p-table>
                </div>
                <pager (selectedPageIndexChange)="selectedPageIndexChange($event)" #pager></pager>
            </div>
        </div>
    </div>
</div>
